// Garde-fous globaux (évite erreurs si Set absent)
window.Eurus = window.Eurus || {};
window.Eurus.loadedScript = window.Eurus.loadedScript || new Set();

// Ne l’enregistre qu’une fois
if (!window.Eurus.loadedScript.has('pagination.js')) {
    window.Eurus.loadedScript.add('pagination.js');

    // Utilitaire : propager sort_by / filtres / view
    const carryQueryParams = (url) => {
        const nextUrl = new URL(url, window.location.href);
        const current = new URL(window.location.href);

        current.searchParams.forEach((val, key) => {
            const isFacet =
                key === 'sort_by' ||
                key === 'view' ||
                key.startsWith('filter.') ||
                key.startsWith('constraint');
            if (isFacet && !nextUrl.searchParams.has(key)) {
                nextUrl.searchParams.set(key, val);
            }
        });

        return nextUrl.toString();
    };

    // Ré-init Alpine sur un sous-arbre (utile après injection/tri)
    const reInitAlpine = (root = document) => {
        if (window.Alpine && typeof Alpine.initTree === 'function') {
            Alpine.initTree(root);
        } else if (window.Alpine && Alpine.discoverUninitializedComponents) {
            // Fallback Alpine 2
            Alpine.discoverUninitializedComponents((el) => {
                if (root.contains(el)) Alpine.initializeComponent(el);
            });
        }
    };

    // --- Déclaration UNIQUE du composant ---
    const defineXPagination = () => {
        // Verrou global inter-scripts pour empêcher double tir
        window.__eurusLoading = window.__eurusLoading || false;

        Alpine.data('xPagination', (sectionId) => ({
            loading: false,

            loadData(url) {
                if (window.__eurusLoading) return;
                this.loading = true;
                window.__eurusLoading = true;

                fetch(carryQueryParams(url))
                    .then((r) => r.text())
                    .then((text) => {
                        const doc = new DOMParser().parseFromString(text, 'text/html');

                        // Grille source (page suivante)
                        const sourceGrid =
                            doc.getElementById('items-grid') ||
                            doc.querySelector('#ProductGrid, #product-grid');

                        if (!sourceGrid) {
                            console.warn('[pagination] items-grid introuvable dans la réponse');
                            return;
                        }

                        // Grille cible (page courante)
                        let targetGrid =
                            document.getElementById('items-grid') ||
                            document.querySelector('#ProductGrid, #product-grid');

                        const blogGrid = document.getElementById('blog-grid');
                        if (blogGrid) targetGrid = blogGrid;

                        // On récupère TOUS les enfants de la page suivante
                        const nextChildren = Array.from(sourceGrid.children);

                        // Append séquentiel des blocs complets (outerHTML) pour préserver les directives
                        nextChildren.forEach((node, i) => {
                            setTimeout(() => {
                                // (filtre léger pour éviter de ré-imbriquer un wrapper inattendu)
                                if (node.matches?.('.card-product, .promotion-block') || node.classList?.length) {
                                    targetGrid.insertAdjacentHTML('beforeend', node.outerHTML);
                                }
                                if (i === nextChildren.length - 1) {
                                    this._renderButton(doc, sectionId);
                                    // Très important : rebind Alpine sur les nouveaux nœuds
                                    reInitAlpine(targetGrid);

                                    // 🔔 prévenir LVDC qu’on a append une page (pour MAJ UI/compteurs/rebind)
                                    window.dispatchEvent(
                                        new CustomEvent('eurus:page-appended', {
                                            detail: { sectionId, appendedCount: nextChildren.length },
                                        })
                                    );
                                }
                            }, i * 40);
                        });
                    })
                    .catch((e) => {
                        console.error('pagination.js loadData error', e);
                    })
                    .finally(() => {
                        this.loading = false;
                        window.__eurusLoading = false;
                    });
            },

            _renderButton(html, sectionId) {
                const destination = document.getElementById('btn-pagination-' + sectionId);
                const source = html.getElementById('btn-pagination-' + sectionId);
                if (destination && source) {
                    destination.innerHTML = source.innerHTML;
                    reInitAlpine(destination);
                }
            },
        }));
    };

    // Enregistrer maintenant (si Alpine prêt) ou à l’init Alpine
    if (window.Alpine && typeof Alpine.data === 'function') {
        defineXPagination();
    } else {
        document.addEventListener('alpine:init', defineXPagination, { once: true });
    }

    // Quand Shopify recharge une section (tri/filtre), re-binder la zone
    document.addEventListener('shopify:section:load', () => {
        const c = document.getElementById('ProductGridContainer');
        if (c) reInitAlpine(c);
    });

    // Event custom possible du thème (si dispo)
    document.addEventListener('Eurus:ajax:refresh', (e) => {
        reInitAlpine(e.target || document);
    });
}
